import { setTraslapos, aplicarTraslapos, setPosWidget } from "./widgetsUtils";
import { propiedadesObjetoToArray } from './dataUtils';
import { PosWidget } from '../classes/widgetClasses';
import { EsquinasWidgets } from '../classes/widgetClasses';
import { ParametrosMovil } from '../classes/mapaClasses';
import { setEstilosMovilHoriz, setEstilosMovilVert } from './styleUtils';
import { createAvisoFullScreen, destroyAvisoFullScreen } from './../configvisores/domElements';

export const movilParamHoriz = new ParametrosMovil(
    "horizontal",
    "horizontal",
    new PosWidget(EsquinasWidgets.topRightLeft, 4),
    new PosWidget(EsquinasWidgets.topRightLeft, 3),
    new PosWidget(EsquinasWidgets.topLeftDown, 1, true),    
    new PosWidget(EsquinasWidgets.topLeftDown, 1, true),
    new PosWidget(EsquinasWidgets.topLeftDown, 1, true),
    "bottom-right",
    setEstilosMovilHoriz
);

export const movilParamVert = new ParametrosMovil(
    "vertical",
    "vertical",
    new PosWidget(EsquinasWidgets.bottomLeftUp, 3),
    new PosWidget(EsquinasWidgets.bottomLeftUp, 2),
    new PosWidget(EsquinasWidgets.topLeftDown, 2, true),
    new PosWidget(EsquinasWidgets.topLeftDown, 3, true),
    new PosWidget(EsquinasWidgets.topLeftDown, 4, true),
    "bottom-center",
    setEstilosMovilVert
);

function esHorizontalBySize(){
    return window.innerWidth > window.innerHeight;
}

function esHorizontalByOrientation(){
    return window.screen.orientation.type.toUpperCase().startsWith("LANDSCAPE");
}

export function esHorizontal(conSupport = false){
    let resp = { es: null, supportOrientation: null };
    try {
        resp.es = esHorizontalByOrientation();
        resp.supportOrientation = true;
    }
    catch {
        resp.es = esHorizontalBySize();
        resp.supportOrientation = false;
    }
    return conSupport ? resp : resp.es;
}

export function setPropiedadesMovilSegunOrientacion(mapView, expands, widgets){
    const horizontal = esHorizontal();
    const { 
        sketchWidgetLayout,
        homePosWidget,
        zoomWidgetLayout,
        zoomPosWidget,
        printPosWidget,
        cercaPosWidget,
        filtroPosWidget,
        popupDockPosition,
        funcSetEstilosMovil
    } = horizontal ? movilParamHoriz : movilParamVert;

    expands.sketch.widget.layout = sketchWidgetLayout;
    setPosWidget(mapView, widgets.home.container, homePosWidget, false);
    widgets.zoom.layout = zoomWidgetLayout;
    setPosWidget(mapView, widgets.zoom.container, zoomPosWidget, false);
    setPosWidget(mapView, expands.print.widget.container, printPosWidget, false);
    setPosWidget(mapView, expands.cerca.widget.container, cercaPosWidget, false);
    setPosWidget(mapView, expands.filtro.widget.container, filtroPosWidget, false);
    mapView.popup.dockOptions.position = popupDockPosition;
    funcSetEstilosMovil();
    if (horizontal && widgets.fullScreen.viewModel.state !== "active"){
        widgets.fullScreen.container.style.border = "2px solid red";
        createAvisoFullScreen(mapView, widgets.fullScreen);
    } else {
        widgets.fullScreen.container.style.border = "none";
        destroyAvisoFullScreen();
    }
}

export function operacionesCambioOrientacion(mapView, expands, widgets){
    //Deben ejecutarse en este orden:
    setTraslapos(mapView, expands);
    aplicarTraslapos(mapView.popup, propiedadesObjetoToArray(expands), -2);
    setPropiedadesMovilSegunOrientacion(mapView, expands, widgets);
}

export function setListenersCambiosOrientacion(...restParam){
    const esHorizontalAux = esHorizontal(true);
    if (esHorizontalAux.supportOrientation){
        window.screen.orientation.onchange = () => {
            operacionesCambioOrientacion(...restParam);
        };
    } else {
        window.addEventListener('resize', () => {
            operacionesCambioOrientacion(...restParam);
        });
    }
    return esHorizontalAux.es;
}